import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'iq-central-front-end-course-skeleton',
  templateUrl: './course-skeleton.component.html',
  styleUrls: ['./course-skeleton.component.css']
})
export class CourseSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
